import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { META_PIXEL_ID, SITE } from './config/site';
import { advisor, dealership } from './data/catalog';

// ============================================================
// CABECERA DEL DOCUMENTO
// ------------------------------------------------------------
// Nada de esto se ve en pantalla. Es lo que leen Google, Meta,
// WhatsApp y cualquier plataforma donde se comparta el link.
// Sin esto, el link compartido sale sin titulo ni descripcion.
// ============================================================

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  if (!content) return;
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}
function setupHead() {
  document.title = SITE.title;
  document.documentElement.lang = 'es';
  setMeta('name', 'description', SITE.description);

  // Mientras sea una maqueta privada, pedimos no ser indexados.
  if (SITE.noindex) {
    setMeta('name', 'robots', 'noindex, nofollow');
  }

  // Como se ve el link al compartirlo por WhatsApp o redes.
  setMeta('property', 'og:type', 'website');
  setMeta('property', 'og:title', SITE.title);
  setMeta('property', 'og:description', SITE.description);
  setMeta('property', 'og:locale', 'es_US');
  setMeta('name', 'twitter:card', 'summary_large_image');
  setMeta('name', 'twitter:title', SITE.title);
  setMeta('name', 'twitter:description', SITE.description);
  if (SITE.canonical) {
    let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = SITE.canonical;
    setMeta('property', 'og:url', SITE.canonical);
  }
}

// ------------------------------------------------------------
// DATOS ESTRUCTURADOS (JSON-LD)
// ------------------------------------------------------------
// Le dice a Google que esto es un concesionario de autos, con
// direccion, horarios y una persona de contacto. Es lo unico de
// SEO que funciona aunque el sitio sea renderizado en el cliente,
// porque va escrito dentro del documento.
//
// OJO: publicar AutoDealer con "Porsche" en el nombre declara ante
// Google que este sitio ES el concesionario. Mientras sea maqueta
// queda desactivado junto con noindex.
// ------------------------------------------------------------
function setupStructuredData() {
  if (SITE.noindex) return;
  const data = {
    '@context': 'https://schema.org',
    '@type': 'AutoDealer',
    name: dealership.name,
    address: {
      '@type': 'PostalAddress',
      streetAddress: '15055 Biscayne Blvd',
      addressLocality: 'North Miami',
      addressRegion: 'FL',
      postalCode: '33181',
      addressCountry: 'US'
    },
    telephone: dealership.phoneLabel,
    url: SITE.canonical || undefined,
    openingHours: ['Mo-Fr 09:00-19:00', 'Sa 09:00-18:00'],
    employee: {
      '@type': 'Person',
      name: advisor.name,
      jobTitle: advisor.role,
      telephone: advisor.phoneLabel,
      email: advisor.email
    }
  };
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
}

// ------------------------------------------------------------
// PIXEL DE META
// ------------------------------------------------------------
// Solo carga si hay un ID en config/site.ts. Vacio = cero peso.
// ------------------------------------------------------------
function setupPixel() {
  if (!META_PIXEL_ID) return;
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function (...args: unknown[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  w.fbq('init', META_PIXEL_ID);
  w.fbq('track', 'PageView');
}
setupHead();
setupStructuredData();
setupPixel();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-333" data-mp="3ud4gugbwcbkh" />);
}